/**
 * Los dos mini KPIs de la card «Seguimiento». Los comparten la card real y su
 * skeleton para que ambos pinten las mismas cajas: `modifier` es el sufijo de
 * la clase `route-report-incidences__stat--*` y `i18nKey` la sub-clave bajo
 * `incidences.stats`.
 */
export const INCIDENCE_STATS = {
  executed: { modifier: 'executed', i18nKey: 'executed_visits' },
  incidents: { modifier: 'incidents', i18nKey: 'incidents' },
} as const;

// Orden de inserción de `INCIDENCE_STATS` (executed, incidents).
export const INCIDENCE_STAT_LIST = Object.values(INCIDENCE_STATS);
